import { InjectionToken } from '@angular/core';

/** The Express response for the current request; only provided during server-side rendering. */
export const SSR_RESPONSE = new InjectionToken<{ status(code: number): unknown }>('SSR_RESPONSE');
